<template>
  <div class="app-layout">
           
    <app-header class="app-header"></app-header>
    <app-main class="app-main" :style="{minHeight: `${height}px`}"></app-main>
    <app-footer class="app-footer"></app-footer>
  </div>
</template>

<script>
import AppHeader from "./AppHeader";
import AppMain from "./AppMain";
import AppFooter from "./AppFooter";
export default {
  name: "AppLayoutIndex",
  components: {
    AppHeader,
    AppMain,
    AppFooter,
  },
  data() {
    return {
      height:document.documentElement.clientHeight-388
    };
  },
};
</script>

<style lang="scss" scoped>
.app-layout {
  height: 100%;
  width: 100%;
  background: #F2F2F2;
  display: flex;
  flex-direction: column;

 
}
 .app-header {
    height: 100px;
  }
  .app-main {
    flex: 1;
  }
  .app-footer {
    // height: 322px;
    overflow: hidden;
  }
</style>